import { joinChannel } from './ws-actions';
import { getChannel } from '../services/ws-channel';

export function emitUserConnected(user) {
  return joinChannel(getChannel({ type: 'user', _id: user._id }));
}

export const NEW_NOTIFICATION = 'user/NEW_NOTIFICATION';
export const SOCKET_NEW_NOTIFICATION = 'new notification';
export const newNotification = payload => ({
  type: NEW_NOTIFICATION,
  payload,
});

export const USER_SET_PERMISSIONS = 'user/SET_PERMISSIONS';
export const SOCKET_USER_PERMISSIONS_CHANGED = 'user permissions changed';
export const setUserPermissions = payload => ({
  type: USER_SET_PERMISSIONS,
  payload,
});

export const SOCKET_USER_UPDATED = 'user updated';



// WEBPACK FOOTER //
// ./app/actions/user-socket.js